import { apiClient } from '@/lib/api/api-client'
import { Gateway } from '../types/gateway'

const GATEWAY_ENDPOINT = '/gateways'

export const gatewayApi = {
  getGateways: (params?: { buildingId?: string; floorId?: string; departmentId?: string }) => {
    return apiClient.get<Gateway[]>(GATEWAY_ENDPOINT, { params })
  },

  getGateway: (id: string) => {
    return apiClient.get<Gateway>(`${GATEWAY_ENDPOINT}/${id}`)
  },

  createGateway: (payload: any) => {
    return apiClient.post<Gateway>(GATEWAY_ENDPOINT, payload)
  },

  updateGateway: (id: string, payload: any) => {
    return apiClient.put<Gateway>(`${GATEWAY_ENDPOINT}/${id}`, payload)
  },

  deleteGateway: (id: string) => {
    return apiClient.delete<void>(`${GATEWAY_ENDPOINT}/${id}`)
  },

  upsertCalibrations: (id: string, payload: any) => {
    return apiClient.post<Gateway>(`${GATEWAY_ENDPOINT}/${id}/calibrations`, payload)
  },

  deleteCalibration: (id: string, tagId: string) => {
    return apiClient.delete<void>(`${GATEWAY_ENDPOINT}/${id}/calibrations/${tagId}`)
  },
}
